module.exports = __webpack_public_path__ + "471f6061e263a6b87262de20323254ab.gif";